import DateIcon from './date.svg';
import DateTimeIcon from './datetime.svg';
import TimeIcon from './time.svg';

export default {
  date: DateIcon,
  time: TimeIcon,
  datetime: DateTimeIcon,
};
